import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
// Import Types
import { DropdownOption } from 'types';
// Import Components
import { Dropdown } from '@geneui/components';
// Import Hooks
import useHasPermission from 'hooks/UseHasPermission';
import { useMenuItem } from 'hooks/UseMenuItem';
// Import Constants
import { l, PARTNER_SETTINGS } from 'constants/common';
// Import Enums
import { MenuItemIdEnum } from 'enums';

interface TemplateCategoryInputProps {
    value: number[];
    onChange: (value: number[], delay?: number) => void;
    wrapWithDiv?: boolean;
}

const TemplateCategoryInput: FC<TemplateCategoryInputProps> = ({ value, onChange, wrapWithDiv = true }) => {
    const { t } = useTranslation();
    const { hasPartnerSettings } = useHasPermission();
    const { convertedData, isLoading } = useMenuItem(MenuItemIdEnum.TemplateCategory);

    const showCategories = hasPartnerSettings(PARTNER_SETTINGS.IsAllowTemplateCategory);

    const dropdownValue = useMemo(() => (value || []).map((id) => id.toString()), [value]);

    const handleChange = (data: DropdownOption<string>[]) => {
        const value = data.map((option) => +option.value);
        onChange(value, 0);
    };

    if (!showCategories) {
        return null;
    }

    const dropdown = (
        <Dropdown
            isMultiSelect={true}
            label={t(l.TemplateCategory)}
            labelAppearance="swap"
            value={dropdownValue}
            onChange={handleChange}
            isLoading={isLoading}
            data={convertedData}
            hasSearch={false}
            placeholder={t(l.TemplateCategory)}
            clearable={true}
        />
    );

    return wrapWithDiv ? <div className="crm-create-template-page-category-input">{dropdown}</div> : dropdown;
};

export default TemplateCategoryInput;
